module.exports = __webpack_public_path__ + "static/collaboration-4-0cbc07996050180f9fa80dbd30691531.svg";